import { useTranslation } from "@ubnt/store.core/lib/hooks/useTranslation";
import { Language } from "@ubnt/store.core/lib/types";
import EN_TRANSLATION from "./en.json";

export const useModelCompareTranslation = () =>
  useTranslation({
    defaultTranslation: EN_TRANSLATION,
    additionalTranslations: {
      [Language.Ar]: () => import("./ar.json").then((res) => res.default),
      [Language.Ca]: () => import("./ca.json").then((res) => res.default),
      [Language.Cs]: () => import("./cs.json").then((res) => res.default),
      [Language.Da]: () => import("./da.json").then((res) => res.default),
      [Language.Nl]: () => import("./nl.json").then((res) => res.default),
      [Language.Fr]: () => import("./fr.json").then((res) => res.default),
      [Language.De]: () => import("./de.json").then((res) => res.default),
      [Language.El]: () => import("./el.json").then((res) => res.default),
      [Language.It]: () => import("./it.json").then((res) => res.default),
      [Language.Ja]: () => import("./ja.json").then((res) => res.default),
      [Language.Ko]: () => import("./ko.json").then((res) => res.default),
      [Language.No]: () => import("./no.json").then((res) => res.default),
      [Language.Pl]: () => import("./pl.json").then((res) => res.default),
      [Language.PtPt]: () => import("./pt-pt.json").then((res) => res.default),
      [Language.EsMx]: () => import("./es-mx.json").then((res) => res.default),
      [Language.Sv]: () => import("./sv.json").then((res) => res.default),
      [Language.Tr]: () => import("./tr.json").then((res) => res.default),
      [Language.Zh]: () => import("./zh.json").then((res) => res.default),
      [Language.Tw]: () =>
        import("./zh-tw.json").then((res) => res.default),
      [Language.PtBr]: () => import("./pt-br.json").then((res) => res.default),
      [Language.Ru]: () => import("./ru.json").then((res) => res.default),
      [Language.EsEs]: () => import("./es-es.json").then((res) => res.default),
    },
  });
